import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ukFlag from '../../../../assets/images/uk_flag.svg';
import hrFlag from '../../../../assets/images/hr_flag.svg';

const LanguageSelector = ({ selectedLanguage, onLanguageChange, align = 'center' }) => {
    // eslint-disable-next-line no-unused-vars
    const { t } = useTranslation();

    return (
        <Wrapper $align={align}>
            <Container>
                <LanguageOption
                    $active={selectedLanguage === 'en'}
                    onClick={() => onLanguageChange('en')}
                    type="button"
                >
                    <FlagImage src={ukFlag} alt="English" />
                    <Label $active={selectedLanguage === 'en'}>EN</Label>
                </LanguageOption>
                <Divider />
                <LanguageOption
                    $active={selectedLanguage === 'hr'}
                    onClick={() => onLanguageChange('hr')}
                    type="button"
                >
                    <FlagImage src={hrFlag} alt="Hrvatski" />
                    <Label $active={selectedLanguage === 'hr'}>HR</Label>
                </LanguageOption>
            </Container>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    justify-content: ${({ $align }) => $align};
    margin-bottom: 1.25rem;
    width: 100%;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    background-color: #f3f4f6;
    border-radius: 999px;
    padding: 0.1875rem;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
`;

const Divider = styled.div`
    width: 4px;
`;

const LanguageOption = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${({ $active }) => $active ? 'rgba(130, 22, 146, 0.08)' : 'transparent'};
    border: 1.5px solid ${({ $active }) => $active ? '#821692' : 'transparent'};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    overflow: hidden;
    
    &:hover {
        background: ${({ $active }) => $active ? 'rgba(130, 22, 146, 0.12)' : 'rgba(0,0,0,0.05)'};
    }
`;

const FlagImage = styled.img`
    width: 20px;
    height: 15px;
    object-fit: cover;
    border-radius: 2px;
    margin-bottom: 0.125rem;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
`;

const Label = styled.span`
    font-size: 0.5rem;
    font-weight: 700;
    color: ${({ $active }) => $active ? '#821692' : '#9ca3af'};
    line-height: 1;
    letter-spacing: 0.3px;
    font-family: inherit;
`;

export default LanguageSelector;
